/**
 * Owner: Masa Bayu
 * File: landing-shared.ts
 * Date:Time: 2026-10-18 16:35
 * Description: Home landing §376 — pemboleh ubah & pembantu dikongsi sesama
 *   fail pecahan landing (rule saiz ≤500 baris).
 */

import type { LandingIconName } from './LandingIcons';
import type { MarketplaceCategoryId } from '../marketplace-projection';

export const AUTO_MS = 5500;

/* §405 — satu ikon garis unik bagi setiap 36 kategori utama taksonomi QX. */
export const CATEGORY_ICON: Record<MarketplaceCategoryId, LandingIconName> = {
  academic: 'doc',
  science: 'bolt',
  technology: 'gear',
  engineering: 'devices',
  mathematics: 'chart',
  medicine: 'heart',
  business: 'briefcase',
  finance: 'receipt',
  law: 'lock',
  'social-sciences': 'users',
  philosophy: 'sparkle',
  religion: 'sun',
  history: 'clock',
  education: 'cap',
  language: 'message',
  literature: 'bookOpen',
  fiction: 'book',
  'scifi-fantasy': 'rocket',
  'children-ya': 'star',
  biography: 'user',
  'self-development': 'flame',
  'arts-design': 'pen',
  'music-performing-arts': 'headset',
  sports: 'medal',
  'food-lifestyle': 'leaf',
  'travel-geography': 'pin',
  environment: 'globe',
  agriculture: 'bag',
  reference: 'search',
  comics: 'grid',
  career: 'checkCircle',
  politics: 'home',
  military: 'shield',
  media: 'share',
  workbooks: 'card',
  alamtologi: 'bookmark',
};

/* §394 — ruling Owner: standard ikon garis SVG untuk SEMUA halaman; CATEGORY_EMOJI
   digugurkan, pemakai kini LandingIcon name={CATEGORY_ICON[id]}. */

export function go(onNavigate: (path: string) => void, path: string): void {
  onNavigate(path);
}
